import { apiProxyRequest } from "Api/apiProxyRequest";

import { normalizeSshKey } from "./normalizeSshKey";

import type { ApiSshKey } from "./types";

type AddSshKeyRequestProps = {
  userId: string;
  value: string;
  /** Optional: the API falls back to the comment in the key. */
  label?: string;
};

export const addSshKeyRequest = ({
  userId,
  value,
  label
}: AddSshKeyRequestProps) =>
  apiProxyRequest<ApiSshKey>(
    `/users/${encodeURIComponent(userId)}/ssh-keys`,
    "POST",
    {
      value,
      ...(label ? { label } : {})
    }
  ).then(normalizeSshKey);
